/* eslint-disable react/display-name */
import * as React from 'react';

const MarkerFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g id="Combined-Shape">
      <path
        d="M12.54,2a6.89,6.89,0,0,1,0,9.42L8,16,3.46,11.4A6.89,6.89,0,0,1,3.46,2l0,0a6.17,6.17,0,0,1,9,0ZM8,4.33a2,2,0,0,0-1.92,2,1.92,1.92,0,1,0,3.84,0A2,2,0,0,0,8,4.33Z"
        style={{ fill: 'inherit', fillRule: 'evenodd' }}
      />
    </g>
  </svg>
);

export default MarkerFilled;
